import React from 'react';
import Input from '~~elements/Input';
import Button from '~~elements/Button';
import Form from '~~elements/Form';
import { SectionDiv } from '../styled';
import CTMultilingual from '../Multilingual';
import { useCreateTournamentDispatch, useCreateTournamentState } from '../useCreateTournament';

const PlanCheck = ({ back, handleSubmit }) => {
  const { contact, creatable, apiLoading } = useCreateTournamentState();
  const dispatch = useCreateTournamentDispatch();

  const handleInputOnChange = (e) => {
    dispatch({
      type: 'UPDATE_CONTACT',
      payload: {
        ...contact,
        [e.target.name]: e.target.value,
      },
    });
  };

  return (
    <SectionDiv>
      <Button width="unset" color="transparentWithBorder" nowrap onClick={back}>
        {CTMultilingual(`FORM.PRE_STEP`)}
      </Button>
      <Form onSubmit={handleSubmit}>
        <div className="box">
          <div className="input-field" />
          <label>{CTMultilingual('CONTACT.WORDING')}</label>
          <div className="description">{CTMultilingual(`TOURNAMENT.PLUGIN.SELECT_ANY_TMP_DESCRIPTION`)}</div>
          <div className="input-field" />
          {/* 聯絡人 */}
          <label>{CTMultilingual('CONTACT.NAME')}</label>
          <div className="input-field">
            <div className="input-box">
              <Input
                width="100%"
                placeholder={CTMultilingual('CONTACT.NAME')}
                name="name"
                value={contact.name}
                onChange={handleInputOnChange}
                textAlign="left"
              />
            </div>
          </div>
          {/* 電話 */}
          <label>{CTMultilingual('CONTACT.PHONE')}</label>
          <div className="input-field">
            <div className="input-box">
              <Input
                width="100%"
                placeholder={CTMultilingual('CONTACT.PHONE')}
                name="phone"
                value={contact.phone}
                onChange={handleInputOnChange}
                textAlign="left"
              />
            </div>
          </div>
          {/* LineID */}
          <label>{CTMultilingual('CONTACT.LINEID')}</label>
          <div className="input-field">
            <div className="input-box">
              <Input
                width="100%"
                placeholder={CTMultilingual('CONTACT.LINEID')}
                name="lineID"
                value={contact.lineID}
                onChange={handleInputOnChange}
                textAlign="left"
              />
            </div>
          </div>
          <Button width="unset" color="red" nowrap type="submit" disabled={!creatable || apiLoading}>
            {CTMultilingual(`COMMON.CREATE`)}
          </Button>
        </div>
      </Form>
    </SectionDiv>
  );
};

export default PlanCheck;
